import React from "react";
import styles from "../../styles/components/home/HelpMeDecideSection.module.css";

const ShortlistCoachPanel = ({
  coaching,
  products = [],
  loading = false,
}) => {
  if (!coaching?.headline && !loading) return null;

  const nameById = new Map(
    products.map((p) => [String(p._id || p.id), p.name || "This product"]),
  );

  return (
    <div className={styles.coachPanel} aria-live="polite">
      {loading && !coaching?.headline ? (
        <p className={styles.coachLoading}>Comparing these options…</p>
      ) : (
        <>
          <p className={styles.coachHeadline}>{coaching.headline}</p>
          {coaching.guidance?.length > 0 && (
            <ul className={styles.coachGuidanceList}>
              {coaching.guidance.map((item) => {
                const name = nameById.get(String(item.productId)) || "Option";
                const key = `${item.productId}-${item.label || "other"}`;
                return (
                  <li key={key} className={styles.coachGuidanceItem}>
                    {item.label && (
                      <span className={styles.coachGuidanceBadge}>
                        {item.label}
                      </span>
                    )}
                    <span className={styles.coachGuidanceName}>{name}</span>
                    <p className={styles.coachGuidanceAdvice}>{item.advice}</p>
                  </li>
                );
              })}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default ShortlistCoachPanel;
